import { useQuery } from '@tanstack/react-query';
import ApiService from '../../ApiService';
import TrackingStatusChip from '../dealers/partials/HAT/TrackingStatusChip';

interface HatTrackingStatusCellProps {
    advertiserId?: number;
}

/**
 * Lazily fetches a single advertiser's HAT tracking status from Trialfire. Used as a DataGrid
 * cell so the grid renders immediately and each (visible) row resolves its own status in the
 * background, showing the TrackingStatusChip loading state until it arrives. Results are cached
 * for 5 minutes so re-renders and pagination don't refetch.
 */
const HatTrackingStatusCell = ({ advertiserId }: HatTrackingStatusCellProps) => {
    const { data: tracking } = useQuery({
        queryKey: ['hatTracking', advertiserId],
        queryFn: () => ApiService.getHatTracking(advertiserId as number).then((res) => res.data),
        enabled: advertiserId != null,
        staleTime: 5 * 60 * 1000,
    });

    return <TrackingStatusChip tracking={tracking ?? null} />;
};

export default HatTrackingStatusCell;
